import React from 'react'
import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import AchievementWidgetBodySkeleton from './AchievementWidgetBodySkeleton'

const AchievementWidgetBodyPlaceholder = () => (
  <AchievementWidgetBodySkeleton
    imageSection={
      <LoadingBox
        width="100%"
        maxWidth="100%"
        height={150}
        mb="1x"
        borderRadius="1x"
      >
        &nbsp;
      </LoadingBox>
    }
    detailSection={
      <LoadingBox width="100%" maxWidth="100%" mb="1x" borderRadius="1x">
        &nbsp;
      </LoadingBox>
    }
  />
)

export default AchievementWidgetBodyPlaceholder
